import { Pipe, PipeTransform } from '@angular/core';
import { fulfillmentOrderStatusToString, WorkOrderPersona } from '@vendasta/work-order';
import { FulfillmentOrderStatus } from '@vendasta/order-fulfillment';
import { BadgeColor } from '@vendasta/galaxy/badge';

@Pipe({
  standalone: true,
  name: 'getFulfillmentBadgeData',
})
export class GetFulfillmentBadgeDataPipe implements PipeTransform {
  transform(
    fulfillmentStatus: FulfillmentOrderStatus,
    badgeColors: Map<FulfillmentOrderStatus, BadgeColor>,
    persona: WorkOrderPersona,
  ): { color: string; status: string } {
    const statusString = fulfillmentOrderStatusToString(fulfillmentStatus, persona);
    const color: BadgeColor = badgeColors.get(fulfillmentStatus);
    return { color, status: statusString };
  }
}
